export default {
  formId: 'createCampoOsForm', //'checkoutForm',
  formField: {
    name: {
      name: 'name',
      label: 'Nombre del Campo*',
      requiredErrorMsg: 'El nombre del Campo es requerido.',
    },
    etiqueta: {
      name: 'etiqueta',
      label: 'Etiqueta del Campo*',
      requiredErrorMsg: 'La etiqueta del Campo es requerida.',
    },
    tipoCampo: {
      name: 'tipoCampo',
      label: 'Tipo de campo',
      requiredErrorMsg: 'El Tipo de campo es requerida.',
    },
    isRequired: {
      name: 'isRequired',
      label: 'Es requerido',
      requiredErrorMsg: 'El Tipo de campo es requerida.',
    },
    opciones: {
      name: 'opciones',
      label: 'Opciones (separadas por coma)',
      requiredErrorMsg: 'El Tipo de campo opciones es requerido.',
    },
    categoria: {
      name: 'categoria',
      label: 'Categoria',
      requiredErrorMsg: 'La categoria es requerida.',
    },
    dependencias: {
      name: 'dependencias',
      label: 'Dependencias',
      requiredErrorMsg: 'Debes selecionar una opcion.',
    },
    formula: {
      name: 'formula',
      label: 'Formula',
      requiredErrorMsg: 'La formula es obligatoria.',
    },
  },
};
